import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import SLBSLogo from './SLBSLogo';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo Area */}
          <div className="logo-container">
            {/* Desktop & Tablet: Full logo with text */}
            <div className="hidden md:block">
              <SLBSLogo 
                variant="full" 
                linkTo="/" 
                className=""
              />
            </div>
            {/* Mobile: Icon only */}
            <div className="block md:hidden">
              <SLBSLogo 
                variant="icon" 
                linkTo="/" 
                className="w-10 h-10"
              />
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <Link to="/" className="text-gray-700 hover:text-[#F7C9D3] transition-colors">
              ホーム
            </Link>
            <div className="relative group">
              <button className="text-gray-700 hover:text-[#F7C9D3] transition-colors">
                サービス
              </button>
              <div className="absolute left-0 mt-2 w-56 bg-white rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <Link to="/services/web" className="block px-4 py-3 hover:bg-gray-50 rounded-t-lg">
                  Webサイト制作
                </Link>
                <Link to="/services/sns" className="block px-4 py-3 hover:bg-gray-50">
                  SNS運用サポート
                </Link>
                <Link to="/services/tiktok-live" className="block px-4 py-3 hover:bg-gray-50">
                  TikTok LIVE・ライブ配信サポート
                </Link>
                <Link to="/services/marketing" className="block px-4 py-3 hover:bg-gray-50">
                  マーケティングサポート
                </Link>
                <Link to="/services/consulting" className="block px-4 py-3 hover:bg-gray-50 rounded-b-lg">
                  ビジネスコンサルティング
                </Link>
              </div>
            </div>
            <Link to="/pricing" className="text-gray-700 hover:text-[#F7C9D3] transition-colors">
              料金
            </Link>
            <div className="relative group">
              <button className="text-gray-700 hover:text-[#F7C9D3] transition-colors">
                Global Business
              </button>
              <div className="absolute left-0 mt-2 w-56 bg-white rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <Link to="/global-business" className="block px-4 py-3 hover:bg-gray-50 rounded-t-lg font-medium">
                  Global Business Solutions
                </Link>
                <Link to="/services/global-expansion" className="block px-4 py-3 hover:bg-gray-50">
                  海外進出支援（Global Expansion）
                </Link>
                <Link to="/services/japan-market-entry" className="block px-4 py-3 hover:bg-gray-50 rounded-b-lg">
                  日本市場進出支援（Japan Market Entry）
                </Link>
              </div>
            </div>
            <Link to="/company" className="text-gray-700 hover:text-[#F7C9D3] transition-colors">
              会社概要
            </Link>
            <Link to="/news" className="text-gray-700 hover:text-[#F7C9D3] transition-colors">
              お知らせ
            </Link>
            <Link 
              to="/contact" 
              className="btn-primary px-6 py-2 rounded-full font-medium"
            >
              お問い合わせ
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            onClick={toggleMenu}
            className="md:hidden"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 space-y-3">
            <Link to="/" className="block py-2 text-gray-700 hover:text-[#F7C9D3]" onClick={toggleMenu}>
              ホーム
            </Link>
            <div className="space-y-2">
              <div className="font-medium text-gray-900">サービス</div>
              <Link to="/services/web" className="block py-2 pl-4 text-gray-700 hover:text-[#F7C9D3]" onClick={toggleMenu}>
                Webサイト制作
              </Link>
              <Link to="/services/sns" className="block py-2 pl-4 text-gray-700 hover:text-[#F7C9D3]" onClick={toggleMenu}>
                SNS運用サポート
              </Link>
              <Link to="/services/tiktok-live" className="block py-2 pl-4 text-gray-700 hover:text-[#F7C9D3]" onClick={toggleMenu}>
                TikTok LIVE・ライブ配信サポート
              </Link>
              <Link to="/services/marketing" className="block py-2 pl-4 text-gray-700 hover:text-[#F7C9D3]" onClick={toggleMenu}>
                マーケティングサポート
              </Link>
              <Link to="/services/consulting" className="block py-2 pl-4 text-gray-700 hover:text-[#F7C9D3]" onClick={toggleMenu}>
                ビジネスコンサルティング
              </Link>
            </div>
            <Link to="/pricing" className="block py-2 text-gray-700 hover:text-[#F7C9D3]" onClick={toggleMenu}>
              料金
            </Link>
            <div className="space-y-2">
              <div className="font-medium text-gray-900">Global Business</div>
              <Link to="/global-business" className="block py-2 pl-4 text-gray-700 hover:text-[#F7C9D3]" onClick={toggleMenu}>
                Global Business Solutions
              </Link>
              <Link to="/services/global-expansion" className="block py-2 pl-4 text-gray-700 hover:text-[#F7C9D3]" onClick={toggleMenu}>
                海外進出支援（Global Expansion）
              </Link>
              <Link to="/services/japan-market-entry" className="block py-2 pl-4 text-gray-700 hover:text-[#F7C9D3]" onClick={toggleMenu}>
                日本市場進出支援（Japan Market Entry）
              </Link>
            </div>
            <Link to="/company" className="block py-2 text-gray-700 hover:text-[#F7C9D3]" onClick={toggleMenu}>
              会社概要
            </Link>
            <Link to="/news" className="block py-2 text-gray-700 hover:text-[#F7C9D3]" onClick={toggleMenu}>
              お知らせ
            </Link>
            <Link to="/contact" className="block btn-primary px-6 py-2 rounded-full font-medium text-center" onClick={toggleMenu}>
              お問い合わせ
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;